export default (queryStringArray: Array = [], searchObject: Object = {}) =>
  queryStringArray.reduce(
    (parent: Object, child: Object) =>
      parent && parent[child] ? parent[child] : null,
    searchObject
  );
